import {AdminApi} from "../api/api";
// eslint-disable-next-line max-len
import {TagSearchInput} from "../api/values/tag-search-input";

export interface ITagItem {
    label: string;
    slug: string;
}

export async function loadTags(
    adminApi: AdminApi,
    mediaId: string,
): Promise<{
    tags: ITagItem[];
}> {
    const tagItemList: ITagItem[] = [];

    const output = await adminApi.getTags(new TagSearchInput({mediaId: mediaId}));

    output.tags.forEach((tag) => {
        tagItemList.push({
            label: tag.label,
            slug: tag.slug,
        });
    });

    return {tags: tagItemList};
}

export async function getTagMap(
    adminApi: AdminApi,
    mediaId: string,
): Promise<Map<string, ITagItem>> {
    const {tags} = await loadTags(adminApi, mediaId);
    const map = new Map<string, ITagItem>();
    tags.forEach((x) => map.set(x.slug, x));
    return map;
}

export function getTagsForTheRevision(tagMap: Map<string, ITagItem>, tags: string[]) {
    const res: any[] = [];
    tags.forEach((x) => {
        res.push(tagMap.get(x));
    });

    return res;
}
